import axios from 'axios';
import api from './api';

export default {
    fetchAll() {
        return axios.post('/stockLocation/fetchAll');
    },
    fetchById(stockLocationId) {
        return axios.post('/stockLocation/fetch', { stockLocationId });
    },
    remove(locationId) {
        return axios.post('/stockLocation/remove', { id: locationId });
    },
    update(locationId, props) {
        return axios.post('/stockLocation/update', {
            id: locationId,
            ...props,
        });
    },
    create() {
        return axios.post('/stockLocation/create');
    },
    add(label, description) {
        return axios.post('/stockLocation/add', { label, description });
    },
    printLabel(id, size, preferredPrinter) {
        return axios.post('/stockLocation/printStockLocationLabel/', {
            stockLocationId: id,
            size,
            preferredPrinter,
        });
    },
    exportLabel(id, size) {
        return api.createGetUrl('/stockLocation/stockLocationLabel/', {
            stockLocationId: id,
            size,
        });
    },
};
